import { useDisplayAmount } from '../../../utils/PerkOptionsUtil';
export var useCurrentPerkStatusDetails = function () {
    var getDisplayAmount = useDisplayAmount();
    var getCurrentPerkStatusDetails = function (currentPerk) {
        var currentPerkDetails = currentPerk.perkDisplaySeqNumber
            ? currentPerk
            : currentPerk.tierPerks[0];
        var title = "$".concat(currentPerk.maxThresholdDisplay);
        var imgName = 'reward-locked-black.svg';
        var imgAltText = 'Not Earned Yet icon';
        var caption = ''; // Options: Choose your Perk, $X Pro Xtra Dollars, Perk Expired
        var subCaption = '';
        var alertMessage = '';
        var displayAmount = getDisplayAmount(currentPerkDetails);
        var newAlertMessage = function () {
            return "".concat(currentPerkDetails.daysLeft, " day").concat(currentPerkDetails.daysLeft < 2 ? '' : 's', " left to claim your Perk");
        };
        // Earned but unclaimed: orange unlock icon
        if (currentPerk.earned && currentPerkDetails.perkStatus === 'UNCLAIMED') {
            if (currentPerkDetails.daysLeft <= 14) {
                alertMessage = newAlertMessage();
            }
            return {
                title: title,
                imgName: 'rewards-unlocked-orange.svg',
                imgAltText: 'Earned but unclaimed icon',
                caption: 'Choose your Perk',
                subCaption: "Unlocked - ".concat(currentPerkDetails.creationTime),
                alertMessage: alertMessage,
            };
        }
        // Not Earned Yet: grey lock icon
        if (!currentPerk.earned &&
            !currentPerkDetails.adminIssued &&
            currentPerkDetails.perkStatus !== 'EXPIRED') {
            return {
                title: title,
                imgName: imgName,
                imgAltText: imgAltText,
                caption: caption,
                subCaption: subCaption,
                alertMessage: alertMessage,
            };
        }
        // Earned and claimed, but expired: grey unlock icon
        if (currentPerkDetails.perkStatus === 'EXPIRED' &&
            !currentPerkDetails.adminIssued &&
            'activationTime' in currentPerkDetails) {
            return {
                title: title,
                imgName: 'checkball-grey.svg',
                imgAltText: 'Earned, expired and selected icon',
                caption: 'Perk Expired',
                subCaption: subCaption,
                alertMessage: alertMessage,
            };
        }
        if (currentPerkDetails.perkStatus === 'EXPIRED' &&
            !currentPerkDetails.adminIssued) {
            // Earned, unclaimed, but expired: grey unlock icon
            return {
                title: title,
                imgName: 'rewards-unlocked-expired.svg',
                imgAltText: 'Earned but expired icon',
                caption: 'Unclaimed Perk Expired',
                subCaption: "Expired - ".concat(currentPerkDetails.expirationTime),
                alertMessage: alertMessage,
            };
        }
        // Expired: grey unlock icon
        if (currentPerkDetails.perkStatus === 'EXPIRED') {
            imgName = 'rewards-unlocked-expired.svg';
            imgAltText = 'Expired icon';
            caption = 'Perk Expired';
        }
        // Redeemed
        // Earned, selected and not expired: grey check icon
        if ((currentPerkDetails.perkStatus === 'ACTIVE' ||
            currentPerkDetails.perkStatus === 'REDEEMED') &&
            currentPerkDetails.daysLeft > 0) {
            caption = "".concat(displayAmount).concat(currentPerkDetails.perkTitle);
            var tempSubCaption = "Selected - ".concat(currentPerkDetails.creationTime);
            if (currentPerkDetails.renewed) {
                tempSubCaption = "Renewed - ".concat(currentPerkDetails.creationTime);
            }
            else if (currentPerkDetails.exchanged) {
                tempSubCaption = "Exchanged - ".concat(currentPerkDetails.creationTime);
            }
            else if (currentPerkDetails.perkStatus === 'REDEEMED') {
                tempSubCaption = "Redeemed";
                var tempTitle = currentPerkDetails.perkTitle
                    .toLowerCase()
                    .includes('tool')
                    ? 'Tool Rental Perk'
                    : currentPerkDetails.perkTitle;
                caption = "".concat(displayAmount).concat(tempTitle);
            }
            imgName = 'checkball-grey.svg';
            imgAltText = 'Earned and selected icon';
            subCaption = tempSubCaption;
            alertMessage = newAlertMessage();
        }
        // Inactive and not expired: grey check icon
        if (currentPerkDetails.perkStatus === 'INACTIVE' &&
            currentPerkDetails.daysLeft > 0) {
            imgName = 'checkball-grey.svg';
            imgAltText = 'Inactive icon';
            title = "$".concat(currentPerk.maxThresholdDisplay);
            caption = 'Temporarily Unavailable';
            subCaption = '';
        }
        // If admin issued, update title to Customer Service Issued
        if (currentPerkDetails.adminIssued) {
            title = 'Customer Service Issued';
        }
        return {
            title: title,
            imgName: imgName,
            imgAltText: imgAltText,
            caption: caption,
            subCaption: subCaption,
            alertMessage: alertMessage,
        };
    };
    return getCurrentPerkStatusDetails;
};
export var getIfPreviousPerk3Lines = function (previousPerk) {
    var previousPerkDetails = previousPerk.perkDisplaySeqNumber
        ? previousPerk
        : previousPerk.tierPerks[0];
    if (previousPerkDetails.perkStatus === 'EXPIRED')
        return false;
    return (previousPerkDetails.adminIssued ||
        previousPerkDetails.renewed ||
        previousPerkDetails.exchanged);
};
